<template>
  <div class="min-h-[calc(100vh-80px)] flex items-center justify-center px-4 py-12">
    <div v-reveal="{ y: 24 }" class="w-full max-w-md card p-7 sm:p-9">

      <!-- Brand -->
      <div class="text-center mb-6">
        <p class="font-serif text-2xl font-bold text-brand-red leading-tight">সাংস্কৃতিক দাপোণ</p>
        <p class="text-xs font-medium tracking-wide text-brand-red-dark/80">Cultural Magazine Dapon</p>
      </div>

      <!-- Notification -->
      <transition name="fade">
        <div v-if="message"
             :class="messageType === 'success' ? 'bg-green-50 text-green-700 border-green-100' : 'bg-red-50 text-red-700 border-red-100'"
             class="p-2.5 mb-4 text-center text-sm font-semibold rounded-md border">
          {{ message }}
        </div>
      </transition>

      <!-- Dynamic Forms -->
      <component
        :is="currentComp"
        @switch="switchTo"
        @success="handleSuccess"
        @error="handleError"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";

// Import the sub components
import LoginForm from "../components/LoginForm.vue";
import SignupForm from "../components/SignupForm.vue";
import OtpVerification from "../components/OtpVerification.vue";
import ForgotPassword from "../components/ForgetPassword.vue";
import ResetPassword from "../components/ResetPassword.vue";

const mode = ref("login"); 
// login | signup | otp | forgot | reset

const message = ref("");
const messageType = ref("error");

const showMessage = (msg, type = "error") => {
  message.value = msg;
  messageType.value = type;
  setTimeout(() => (message.value = ""), 3500);
};

const switchTo = (newMode) => {
  mode.value = newMode;
};

const handleSuccess = (msg) => showMessage(msg, "success");
const handleError = (msg) => showMessage(msg, "error");

const currentComp = computed(() => {
  return {
    login: LoginForm,
    signup: SignupForm,
    otp: OtpVerification,
    forgot: ForgotPassword,
    reset: ResetPassword,
  }[mode.value];
});
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
